


















































































































































































































































































































import Vue from "vue";
import FormSection from "@/components/FormSection.vue";
import DateInput from "@/components/DateInput.vue";

import PartPerson, { PartPersonDefaultProps } from "../models/PartPerson";
import partnerStore, { PartnerStore } from "../services/PartnerStore";
import cityStore, { CityStore } from "@/modules/city/services/CityStore";
import { ValidationRules } from "@/models/Validation";
import { PartPersonValidationRules as partPersonRules } from "../models/PartPerson";
import { PartProdRelationValidationRules as partProdRelRules } from "../models/PartProdRelation";



interface Data {
  partnerStore: PartnerStore;
  cityStore: CityStore;
  partPersonRules: ValidationRules;
  partProdRelRules: ValidationRules;
  valid: boolean;
}

interface Methods {
  savePartPerson(partPerson: PartPerson): void;
  cancelEdit(): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    FormSection,
    DateInput,
  },

  data() {
    return {
    partnerStore,
    cityStore,
    partPersonRules: partPersonRules,
    partProdRelRules: partProdRelRules,
    valid: false,
    };
  },

  async beforeMount() {
    const partPersonId = Number(this.$route.params.partPersonId);    
    if (partPersonId) {
      await partnerStore.loadPartPerson(partPersonId)
    }
    else {
      partnerStore.partPerson = { ...PartPersonDefaultProps };
    }
  },

  methods: {
    async savePartPerson() {
      this.partnerStore.partPerson.partnerId = Number(this.$route.params.partnerId);
      await partnerStore.updatePartPerson();
    },

    cancelEdit() {
      partnerStore.partPerson = { ...PartPersonDefaultProps };
      this.$router.push(`/partners/${this.$route.params.partnerId}/${this.$route.params.source}`);
    },
  },
});
